import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomMessageService, UtilService, LocalStorageService } from 'library';
import { CategoryRequestService } from 'projects/store/src/app/services/api/v1/category-request.service';
import { RequestService } from 'projects/store/src/app/services/api/v1/request.service';
import { PixelService } from 'projects/store/src/app/services/api/v1/pixel.service';
import { SalesSimulatorKredicashComponentV3 } from '../sales-simulator-kredicash-v3.component';

/**
 * Componente Versión V2 del Simulador Kredicash V3
 * Hereda toda la lógica del componente principal
 * Utiliza el template estilo V2
 */
@Component({
  selector: 'app-sales-simulator-kredicash-v3-version-v2',
  templateUrl: './sales-simulator-kredicash-v3-v2.component.html'
})
export class SalesSimulatorKredicashV3VersionV2Component extends SalesSimulatorKredicashComponentV3 implements OnInit {

  constructor(
    protected override categoryRequestService: CategoryRequestService,
    protected override utilService: UtilService,
    protected override customMessageService: CustomMessageService,
    protected override requestService: RequestService,
    protected override localStorageService: LocalStorageService,
    protected override metaPixelService: PixelService,
    protected override route: ActivatedRoute,
    protected override router: Router,
    protected override cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) protected override platformId: Object
  ) {
    super(
      categoryRequestService,
      utilService,
      customMessageService,
      requestService,
      localStorageService,
      metaPixelService,
      route,
      router,
      cdr,
      platformId
    );
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }
}

/**
 * Componente Versión V3 del Simulador Kredicash V3
 * Hereda toda la lógica del componente principal
 * Utiliza el template estilo V3 con diseño moderno
 * Incluye métodos adicionales para incrementar/decrementar monto
 */
@Component({
  selector: 'app-sales-simulator-kredicash-v3-version-v3',
  templateUrl: './sales-simulator-kredicash-v3-v3.component.html'
})
export class SalesSimulatorKredicashV3VersionV3Component extends SalesSimulatorKredicashComponentV3 implements OnInit {

  // Índice del precio seleccionado para navegación con botones +/-
  selectedPriceIndex: number = 0;

  constructor(
    protected override categoryRequestService: CategoryRequestService,
    protected override utilService: UtilService,
    protected override customMessageService: CustomMessageService,
    protected override requestService: RequestService,
    protected override localStorageService: LocalStorageService,
    protected override metaPixelService: PixelService,
    protected override route: ActivatedRoute,
    protected override router: Router,
    protected override cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) protected override platformId: Object
  ) {
    super(
      categoryRequestService,
      utilService,
      customMessageService,
      requestService,
      localStorageService,
      metaPixelService,
      route,
      router,
      cdr,
      platformId
    );
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Override de onExtractMinMaxPrices para inicializar el índice
   */
  override onExtractMinMaxPrices(): void {
    super.onExtractMinMaxPrices();
    // Inicializar el índice al precio máximo (último en la lista ordenada)
    const sortedPrices = this.prices().sort((a: number, b: number) => a - b);
    this.selectedPriceIndex = sortedPrices.indexOf(this.selectedPrice);
  }

  /**
   * Incrementa el monto seleccionado
   */
  increaseAmount(): void {
    const sortedPrices = this.prices().sort((a: number, b: number) => a - b);
    if (this.selectedPriceIndex < sortedPrices.length - 1) {
      this.selectedPriceIndex++;
      this.selectedPrice = sortedPrices[this.selectedPriceIndex];
      this.selectedProduct = this.getProductByPrice(this.selectedPrice);
      this.autoSimulate();
    }
  }

  /**
   * Decrementa el monto seleccionado
   */
  decreaseAmount(): void {
    const sortedPrices = this.prices().sort((a: number, b: number) => a - b);
    if (this.selectedPriceIndex > 0) {
      this.selectedPriceIndex--;
      this.selectedPrice = sortedPrices[this.selectedPriceIndex];
      this.selectedProduct = this.getProductByPrice(this.selectedPrice);
      this.autoSimulate();
    }
  }

  /**
   * Verifica si se puede incrementar el monto
   */
  canIncrease(): boolean {
    const sortedPrices = this.prices().sort((a: number, b: number) => a - b);
    return this.selectedPriceIndex < sortedPrices.length - 1;
  }

  /**
   * Verifica si se puede decrementar el monto
   */
  canDecrease(): boolean {
    return this.selectedPriceIndex > 0;
  }

  /**
   * Maneja el cambio del slider de cuotas
   */
  onQuotaSliderChange(value: number | undefined): void {
    if (value === undefined) return;
    this.selectedDay = value * 15;
    this.autoSimulate();
  }

  /**
   * Obtiene el número de cuotas seleccionadas
   */
  get selectedQuotas(): number {
    return this.selectedDay / 15;
  }
}
